import script from "./VideoDetailView.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoDetailView.vue?vue&type=script&lang=ts&setup=true"

import "./VideoDetailView.vue?vue&type=style&index=0&id=6b61374c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b61374c"]])

export default __exports__